export const RESET_FOCUS_ID = 'reset-focus';
